import EditableCustomizableSelect from 'Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';

const SelectTurnType = ({ field, onChange }) => {
  const dataArray = field?.defaultItem?.map((fd) => ({
    ItemValue: fd.Id,
    ItemContent: fd.Name,
  }));

  const default_value = field?.defaultItem?.filter(
    (fl) => fl.Id === Number(field.Value)
  )[0].Name;

  const label = FindLangKey(
    'lab-patient-tarikh-type-label'
  );

  return (
    <React.Fragment>
      <EditableCustomizableSelect
        SelectableDataArray={dataArray}
        initialData={[
          {
            ItemValue: default_value,
            ItemContent: default_value,
          },
        ]}
        isSingle
        label={label}
        onChange={onChange}
        value={default_value}
      />
    </React.Fragment>
  );
};

export default SelectTurnType;
